<!-- Container -->
<div class="container">

  <ul>
    <li>
      From the main menu, go to "Settings" to add a new vessel or check for app updates
    </li>
  </ul>

</div>
